import { render, staticRenderFns } from "./NoticeBanner.vue?vue&type=template&id=d633cd54&"
import script from "./NoticeBanner.vue?vue&type=script&lang=js&"
export * from "./NoticeBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports